<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="ProjectTeam"
              @submit.prevent="onFileUpload"
            >
                <div class="content">
                    <h1>Project Team</h1>
                    <div style="margin-top: 2%;">
                    <h2>Borrower</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="FullSummaryApplication.Borrower.CompanyName"
                            error="This field is required"
                            name="input-borrower-company-name"
                            required
                            rules="required"
                            placeholder="Company Name"
                            type="text"/>
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.Borrower.StateOfEntity"
                            :options="States"
                            error="This field is required"
                            name="input-borrower-state-of-entity"
                            required
                            rules="required"
                            placeholder="State of Entity"
                            type="text"/>
                        </div>
                    </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Address.Street1"
                          error="This field is required"
                          name="input-borrower-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Address.Street2"
                          error="This field is required"
                          name="input-borrower-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Address.Zip"
                          error="This field is required"
                          name="input-borrower-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Address.City"
                          error="This field is required"
                          name="input-borrower-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="FullSummaryApplication.Borrower.Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-borrower-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Address.Country"
                          error="This field is required"
                          name="input-borrower-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contact</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Contact.Name"
                          error="This field is required"
                          name="input-borrower-contact-name"
                          required
                          rules="required"
                          placeholder="Contact Person Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Contact.Phone"
                          error="This field is required"
                          name="input-borrower-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Contact Person Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Borrower.Contact.Email"
                          error="This field is required"
                          name="input-borrower-contact-email"
                          required
                          rules="required|email"
                          placeholder="Contact Person Email"
                          type="text"
                          />
                    </div>
                </div>
                </div>
                <div>
                    <br>
                    <h2>General Partner or Managing Member</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.GeneralPartnerOrManagingMember"
                            :options="generalPartnerManagingMember"
                            error="This field is required"
                            name="input-general-partner-or-managing-member"
                            required
                            rules="required"
                            placeholder="General Partner or Managing Member"
                            type="text"/>
                        </div>
                    </div>
                    <div v-if="FullSummaryApplication.GeneralPartnerOrManagingMember != 'Neither'">
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="FullSummaryApplication.GeneralPartner.CompanyName"
                            error="This field is required"
                            name="input-general-partner-company-name"
                            required
                            rules="required"
                            placeholder="Company Name"
                            type="text"/>
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.GeneralPartner.StateOfEntity"
                            :options="States"
                            error="This field is required"
                            name="input-general-partner-state-of-entity"
                            required
                            rules="required"
                            placeholder="State of Entity"
                            type="text"/>
                        </div>
                    </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Address.Street1"
                          error="This field is required"
                          name="input-general-partner-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Address.Street2"
                          error="This field is required"
                          name="input-general-partner-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Address.Zip"
                          error="This field is required"
                          name="input-general-partner-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Address.City"
                          error="This field is required"
                          name="input-general-partner-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="FullSummaryApplication.GeneralPartner.Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-general-partner-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Address.Country"
                          error="This field is required"
                          name="input-general-partner-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contact</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Contact.Name"
                          error="This field is required"
                          name="input-general-partner-contact-name"
                          required
                          rules="required"
                          placeholder="Contact Person Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Contact.Phone"
                          error="This field is required"
                          name="input-general-partner-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Contact Person Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.GeneralPartner.Contact.Email"
                          error="This field is required"
                          name="input-general-partner-contact-email"
                          required
                          rules="required|email"
                          placeholder="Contact Person Email"
                          type="text"
                          />
                    </div>
                </div>
                </div>
                </div>
                <div>
                    <br>
                    <h2>Attorney</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="FullSummaryApplication.Attorney.CompanyName"
                            error="This field is required"
                            name="input-attorney-company-name"
                            required
                            rules="required"
                            placeholder="Company Name"
                            type="text"/>
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.Attorney.StateOfEntity"
                            :options="States"
                            error="This field is required"
                            name="input-attorney-state-of-entity"
                            required
                            rules="required"
                            placeholder="State of Entity"
                            type="text"/>
                        </div>
                    </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Address.Street1"
                          error="This field is required"
                          name="input-attorney-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Address.Street2"
                          error="This field is required"
                          name="input-attorney-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Address.Zip"
                          error="This field is required"
                          name="input-attorney-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Address.City"
                          error="This field is required"
                          name="input-attorney-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="FullSummaryApplication.Attorney.Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-attorney-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Address.Country"
                          error="This field is required"
                          name="input-attorney-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contact</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Contact.Name"
                          error="This field is required"
                          name="input-attorney-contact-name"
                          required
                          rules="required"
                          placeholder="Contact Person Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Contact.Phone"
                          error="This field is required"
                          name="input-attorney-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Contact Person Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Attorney.Contact.Email"
                          error="This field is required"
                          name="input-attorney-contact-email"
                          required
                          rules="required|email"
                          placeholder="Contact Person Email"
                          type="text"
                          />
                    </div>
                </div>
                </div>
                <br>
                <h2>Additional Members</h2>
                <div class="columns">
                    <div class="column">
                        <vee-checkbox
                        v-model="FullSummaryApplication.OptionalContacts"
                        error="This field is required"
                        :options="optionalContacts"
                        name="input-optional-contacts"
                        label="Do you have any additional team members to add?"
                        type="text"/>
                    </div>
                </div>
                <br>
                <div v-if="FullSummaryApplication.OptionalContacts.includes('Architect')">
                    <h2>Architect</h2>
                    <div>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="FullSummaryApplication.Architect.CompanyName"
                            error="This field is required"
                            name="input-architect-company-name"
                            required
                            rules="required"
                            placeholder="Company Name"
                            type="text"/>
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.Architect.StateOfEntity"
                            :options="States"
                            error="This field is required"
                            name="input-architect-state-of-entity"
                            required
                            rules="required"
                            placeholder="State of Entity"
                            type="text"/>
                        </div>
                    </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Address.Street1"
                          error="This field is required"
                          name="input-architect-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Address.Street2"
                          error="This field is required"
                          name="input-architect-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Address.Zip"
                          error="This field is required"
                          name="input-architect-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Address.City"
                          error="This field is required"
                          name="input-architect-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="FullSummaryApplication.Architect.Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-architect-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Address.Country"
                          error="This field is required"
                          name="input-architect-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contact</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Contact.Name"
                          error="This field is required"
                          name="input-architect-contact-name"
                          required
                          rules="required"
                          placeholder="Contact Person Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Contact.Phone"
                          error="This field is required"
                          name="input-architect-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Contact Person Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Architect.Contact.Email"
                          error="This field is required"
                          name="input-architect-contact-email"
                          required
                          rules="required|email"
                          placeholder="Contact Person Email"
                          type="text"
                          />
                    </div>
                </div>
                </div>
                </div>
                <div v-if="FullSummaryApplication.OptionalContacts.includes('Property Management Company')">
                    <br>
                    <h2>Property Management Company</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="FullSummaryApplication.PropertyManagementCompany.CompanyName"
                            error="This field is required"
                            name="input-property-management-company-name"
                            required
                            rules="required"
                            placeholder="Company Name"
                            type="text"/>
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.PropertyManagementCompany.StateOfEntity"
                            :options="States"
                            error="This field is required"
                            name="input-property-management-company-state-of-entity"
                            required
                            rules="required"
                            placeholder="State of Entity"
                            type="text"/>
                        </div>
                    </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Address.Street1"
                          error="This field is required"
                          name="input-property-management-company-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Address.Street2"
                          error="This field is required"
                          name="input-property-management-company-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Address.Zip"
                          error="This field is required"
                          name="input-property-management-company-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Address.City"
                          error="This field is required"
                          name="input-property-management-company-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="FullSummaryApplication.PropertyManagementCompany.Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-property-management-company-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Address.Country"
                          error="This field is required"
                          name="input-property-management-company-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contact</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Contact.Name"
                          error="This field is required"
                          name="input-property-management-company-contact-name"
                          required
                          rules="required"
                          placeholder="Contact Person Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Contact.Phone"
                          error="This field is required"
                          name="input-property-management-company-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Contact Person Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.PropertyManagementCompany.Contact.Email"
                          error="This field is required"
                          name="input-property-management-company-contact-email"
                          required
                          rules="required|email"
                          placeholder="Contact Person Email"
                          type="text"
                          />
                    </div>
                </div>
                </div>
                <div v-if="FullSummaryApplication.OptionalContacts.includes('Consultant')">
                    <br>
                    <h2>Consultant</h2>
                    <div class="columns">
                        <div class="column">
                            <vee-textbox
                            v-model="FullSummaryApplication.Consultant.CompanyName"
                            error="This field is required"
                            name="input-consultant-name"
                            required
                            rules="required"
                            placeholder="Company Name"
                            type="text"/>
                        </div>
                        <div class="column">
                            <vee-dropdown
                            v-model="FullSummaryApplication.Consultant.StateOfEntity"
                            :options="States"
                            error="This field is required"
                            name="input-consultant-state-of-entity"
                            required
                            rules="required"
                            placeholder="State of Entity"
                            type="text"/>
                        </div>
                    </div>
                <h3>Address</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Address.Street1"
                          error="This field is required"
                          name="input-consultant-street1"
                          required
                          rules="required"
                          placeholder="Street Address"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Address.Street2"
                          error="This field is required"
                          name="input-consultant-street2"
                          placeholder="Apt / Unit"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Address.Zip"
                          error="This field is required"
                          name="input-consultant-zip"
                          required
                          rules="required"
                          placeholder="Zip"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Address.City"
                          error="This field is required"
                          name="input-consultant-city"
                          required
                          rules="required"
                          placeholder="City"
                          type="text"
                          />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                          v-model="FullSummaryApplication.Consultant.Address.State"
                          :options="States"
                          error="This field is required"
                          name="input-consultant-state"
                          required
                          rules="required"
                          placeholder="State"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Address.Country"
                          error="This field is required"
                          name="input-consultant-country"
                          required
                          rules="required"
                          readonly
                          placeholder="Country"
                          type="text"
                          />
                    </div>
                </div>
                <h3>Contact</h3>
                <div class="columns">
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Contact.Name"
                          error="This field is required"
                          name="input-consultant-contact-name"
                          required
                          rules="required"
                          placeholder="Contact Person Name"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Contact.Phone"
                          error="This field is required"
                          name="input-consultant-contact-phone"
                          required
                          rules="required|phone"
                          placeholder="Contact Person Phone"
                          type="text"
                          />
                    </div>
                    <div class="column">
                        <vee-textbox
                          v-model="FullSummaryApplication.Consultant.Contact.Email"
                          error="This field is required"
                          name="input-consultant-contact-email"
                          required
                          rules="required|email"
                          placeholder="Contact Person Email"
                          type="text"
                          />
                    </div>
                </div>
                </div>
                <div class="columns">
                  <div class="column" style="text-align: left;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="prevPage"
                      >
                      Back
                      </button>
                  </div>
                  <div class="column" style="text-align: right;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="nextPage"
                      >
                      Next
                      </button>
                  </div>
              </div>
                </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import { getPropertyValueOrDefault } from "@/utilities/functions.js";
// import buildPropertyInfoObject from "@/utilities/get-property-info-object.js";
// import axios from "axios";
import options from "@/utilities/options";

export default {
  name: 'ProjectTeam',
  mixins: [options],
  data() {
    return {
      FullSummaryApplication: null,
    };
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullSummaryApplication = await this.$vlf.getItem('fullSummaryApplication');
    setInterval(() => {
        this.onNo();
    }, 1000);
  },
  methods: {
    onNo(){
        if(this.FullSummaryApplication.GeneralPartnerOrManagingMember == "Neither"){
            this.FullSummaryApplication.GeneralPartner = {Role: null, CompanyName: null, StateOfEntity: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }};
        }
        if(!this.FullSummaryApplication.OptionalContacts.includes("Architect")){
            this.FullSummaryApplication.Architect = {Role: "Architect", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }};
        }
        if(!this.FullSummaryApplication.OptionalContacts.includes("Property Management Company")){
            this.FullSummaryApplication.PropertyManagementCompany = {Role: "Management Agent", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }};
        }
        if(!this.FullSummaryApplication.OptionalContacts.includes("Consultant")){
            this.FullSummaryApplication.Consultant = {Role: "Consultant", CompanyName: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }, Contact: { Name: null, Email: null, Phone: null }};
        }
    },
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "SiteInformation",
                params: { siteId: 1  },
            });
        }
    },
    async prevPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "RFPProjectInformation",
            });
        }
    },
  }
};
</script>